(function () {
  'use strict';

  // Action icons for the directory cards. Inline so they cost no requests
  // and inherit currentColor from the button state.
  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON_GLOBE = SVG_OPEN +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<line x1="2" y1="12" x2="22" y2="12"></line>' +
    '<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>';
  var ICON_PHONE = SVG_OPEN +
    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>';
  var ICON_PIN = SVG_OPEN +
    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>' +
    '<circle cx="12" cy="10" r="3"></circle></svg>';

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    var R = 3959; // miles
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // --- Container sizing ----------------------------------------------------
  //
  // Leaflet measures its container once, at construction, and never
  // re-measures on its own. If that measurement happens while the container
  // has no size — the stylesheet hasn't applied yet, the section is still
  // laying out, the page is in a collapsed or background panel, a tab is
  // opened in the background — then the tile grid and the initial fitBounds
  // are both computed for a viewport that doesn't exist. fitBounds against a
  // zero-height box falls through to the minimum zoom, which is why the map
  // came up showing the whole world instead of the UK, with a single strip of
  // tiles and black everywhere else.
  //
  // So: wait for a real size before building, and re-measure afterwards
  // whenever the box changes.

  function hasSize(el) {
    return el.clientWidth > 0 && el.clientHeight > 0;
  }

  function whenSized(el, cb) {
    if (hasSize(el)) { cb(); return; }

    var settled = false;
    var ro = null;
    var poll = null;
    var giveUp = null;

    function cleanup() {
      if (ro) { ro.disconnect(); ro = null; }
      if (poll) { clearInterval(poll); poll = null; }
      if (giveUp) { clearTimeout(giveUp); giveUp = null; }
    }

    function check() {
      if (settled || !hasSize(el)) return;
      settled = true;
      cleanup();
      cb();
    }

    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(check);
      ro.observe(el);
    }
    // Covers browsers without ResizeObserver, and size changes that come
    // from an ancestor rather than the element itself.
    poll = setInterval(check, 100);

    // Never leave the map unbuilt. If the container is still sizeless after
    // a few seconds, build anyway — the observer installed below will put it
    // right the moment it does get a size.
    giveUp = setTimeout(function () {
      if (settled) return;
      settled = true;
      cleanup();
      cb();
    }, 3000);
  }

  // Keeps Leaflet's idea of the viewport in step with the real box, for the
  // whole life of the page: window resize, orientation change, the browser
  // panel being widened, a late webfont reflowing the section, the theme
  // editor resizing the preview.
  //
  // The poll is the part that actually guarantees this, and it is not
  // belt-and-braces. ResizeObserver, the window resize event and
  // requestAnimationFrame are all delivered in the event loop's "update the
  // rendering" step, so a window the compositor isn't painting — occluded by
  // another window, minimised, in a panel that is covered — runs none of
  // them, while still reporting document.visibilityState as "visible" and
  // still reflowing its layout. Measured on this page: after a resize in that
  // state, ResizeObserver, resize and rAF had each fired exactly zero times
  // while a timer saw the container go from 1440x900 to 900x350. A map that
  // only listened for those events would stay stale for as long as the window
  // was covered, and the visitor would find it broken the moment they looked
  // at it. Timers keep running, so the poll is what makes this reliable; the
  // events are kept because they react faster when the page is being painted.
  function watchSize(mapEl, map, onResize) {
    var lastW = mapEl.clientWidth;
    var lastH = mapEl.clientHeight;
    var timer = null;

    function sync() {
      timer = null;
      var w = mapEl.clientWidth;
      var h = mapEl.clientHeight;
      if (!w || !h) return;            // hidden again; wait for the next change
      if (w === lastW && h === lastH) return;
      lastW = w;
      lastH = h;
      map.invalidateSize({ animate: false, pan: false });
      if (onResize) onResize();
    }

    // Debounces a burst of events into one re-measure. A timer, not rAF, for
    // the reason above.
    function schedule() {
      if (timer) return;
      timer = setTimeout(sync, 100);
    }

    // Two reads of a cached layout value; cheap enough to leave running.
    setInterval(sync, 400);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(schedule).observe(mapEl);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    // Late-loading webfonts and images can still shift the layout after
    // DOMContentLoaded, and a page restored from the back/forward cache
    // never fires either of the above.
    window.addEventListener('load', schedule);
    window.addEventListener('pageshow', schedule);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(schedule).catch(function () {});
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });
  }

  function showMapUnavailable(mapEl) {
    var note = document.createElement('div');
    note.className = 'map-unavailable';
    note.setAttribute('role', 'status');
    note.textContent = 'The interactive map could not be loaded. The full distributor list is below.';
    mapEl.appendChild(note);
  }

  function init() {
    var mapEl = document.getElementById('merchant-map');
    if (!mapEl || mapEl.getAttribute('data-merchant-map') === 'ready') return;
    mapEl.setAttribute('data-merchant-map', 'ready');
    whenSized(mapEl, function () { build(mapEl); });
  }

  function build(mapEl) {
    var listContainer = document.getElementById('merchant-directory-list');
    var stockistCount = document.getElementById('stockistCount');
    var allStores = [];
    var map = null;
    var bounds = null;
    var customIcon = null;
    // True while the stores still need to be framed — either the first fit
    // hasn't run, or it ran against a container too small to mean anything.
    var needsFit = true;
    // Set once the visitor moves the map themselves or runs a search. From
    // then on the view belongs to them and a resize only re-measures it.
    var viewIsUsers = false;
    // Guards against our own fitBounds being read as a user zoom.
    var fitting = false;
    var settleFit = null;

    if (typeof L !== 'undefined') {
      map = L.map(mapEl, { scrollWheelZoom: false }).setView([54.5, -2.5], 6);

      mapEl.addEventListener('click', function () {
        map.scrollWheelZoom.enable();
        mapEl.classList.add('map-active');
      });
      document.addEventListener('click', function (e) {
        if (!mapEl.contains(e.target)) {
          map.scrollWheelZoom.disable();
          mapEl.classList.remove('map-active');
        }
      });
      map.touchZoom.enable();
      map.dragging.enable();

      // Only the gestures that genuinely move the map count. A bare click on
      // the container does not — that just arms scroll zoom — and treating it
      // as an interaction would stop the overview re-framing for no reason.
      function viewTakenOver() { viewIsUsers = true; }
      map.on('dragstart', viewTakenOver);
      map.on('zoomstart', function () { if (!fitting) viewTakenOver(); });
      mapEl.addEventListener('wheel', function () {
        if (map.scrollWheelZoom.enabled()) viewTakenOver();
      }, { passive: true });
      mapEl.addEventListener('dblclick', viewTakenOver);

      // Basemap: Esri dark grey canvas.
      //
      // This replaced CARTO's dark_all. CARTO now watermarks its free
      // basemaps — the tiles still return HTTP 200, but with "API KEY
      // REQUIRED" burned into the image, so nothing looked broken in the
      // network tab while the map read as unusable. Esri's canvas needs no
      // key and matches the dark UI closely.
      //
      // Esri splits this style into two layers: the base (landmass, roads)
      // and a separate reference layer carrying place labels. Both are
      // needed, with labels on top.
      var ESRI_CANVAS = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/';
      var esriAttribution = 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; ' +
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

      // updateWhenIdle is deliberately left at Leaflet's default (on for
      // touch, off for desktop). Forcing it on held the new tiles back until
      // panning stopped, which made a resized map look empty for longer than
      // it had to.
      L.tileLayer(ESRI_CANVAS + 'World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: esriAttribution,
        maxZoom: 16,
        keepBuffer: 2
      }).addTo(map);

      // Labels go in their own pane between the tiles (200) and the markers
      // (600), so place names sit above the basemap without ever covering a
      // distributor pin.
      map.createPane('labels');
      map.getPane('labels').style.zIndex = 350;
      map.getPane('labels').style.pointerEvents = 'none';

      L.tileLayer(ESRI_CANVAS + 'World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 16,
        keepBuffer: 2,
        pane: 'labels'
      }).addTo(map);

      customIcon = L.divIcon({
        className: 'custom-leaflet-marker',
        html:
          '<div class="glowing-marker-wrapper">' +
            '<div class="glowing-marker-halo"></div>' +
            '<div class="glowing-marker">' +
              '<div class="glowing-marker-inner">' +
                '<span class="glowing-marker-label">BALLISTOL</span>' +
              '</div>' +
            '</div>' +
          '</div>',
        iconSize: [30, 40],
        iconAnchor: [15, 38],
        popupAnchor: [0, -35]
      });

      bounds = L.latLngBounds();
    } else {
      // Leaflet is a third-party CDN script, so it can fail where the rest of
      // the page is fine. The directory is the part people actually need, so
      // it still renders; only the map itself degrades.
      showMapUnavailable(mapEl);
    }

    // The directory panel floats over the right-hand side of the map on
    // desktop, so pins fitted edge-to-edge end up underneath it. Reserve the
    // strip it actually covers, measured from the element rather than assumed
    // from the breakpoint: below 900px it stops overlapping and drops below
    // the map, and then it reserves nothing. Capped so a narrow desktop can't
    // squeeze the usable area down to nothing.
    function fitPadding() {
      var pad = 30;
      var right = pad;
      var overlay = document.querySelector('.directory-overlay');
      if (overlay) {
        var o = overlay.getBoundingClientRect();
        var box = mapEl.getBoundingClientRect();
        var overlaps = o.width && o.height &&
          o.left < box.right && o.right > box.left &&
          o.top < box.bottom && o.bottom > box.top;
        if (overlaps) {
          right = Math.min(Math.round(box.right - o.left) + 20, Math.round(box.width * 0.6));
        }
      }
      return {
        paddingTopLeft: L.point(pad, pad),
        paddingBottomRight: L.point(right, pad)
      };
    }

    // Frames every distributor. Refuses to run against a container that has
    // no usable size and leaves needsFit set, so the resize watcher retries
    // once the box is real.
    function fitToStores() {
      if (!map || !bounds || !bounds.isValid()) return;
      if (!hasSize(mapEl)) { needsFit = true; return; }
      needsFit = false;
      // fitBounds fires zoomstart; flagged so it isn't mistaken for the
      // visitor taking the view over.
      fitting = true;
      map.fitBounds(bounds, fitPadding());
      fitting = false;
    }

    function buildCard(store, searchLat, searchLng) {
      var card = document.createElement('div');
      card.className = 'directory-card';

      var distanceText = '';
      if (searchLat != null && searchLng != null) {
        var dist = getDistance(searchLat, searchLng, store.position.lat, store.position.lng);
        // Leads the address line after a search; the separator keeps the two
        // readable when they share a row.
        distanceText = '<span class="store-distance">' + dist.toFixed(1) + ' mi</span>' +
                       '<span class="store-sep"> &middot; </span>';
      }

      // The pin placeholder is always rendered; the logo, when there is one,
      // is layered over it. Several distributor logos are hosted on the
      // distributors' own domains and on graph.facebook.com, which now
      // returns 401 without a token — hiding a broken image on its own left
      // an empty grey square, so the placeholder underneath shows instead.
      var placeholderHtml =
        '<div class="store-placeholder-svg">' +
          '<svg width="32" height="32" viewBox="0 0 24 24" fill="#ff0000" aria-hidden="true">' +
            '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>' +
          '</svg>' +
        '</div>';

      var logoHtml = placeholderHtml;
      if (store.logo) {
        logoHtml +=
          '<img src="' + escapeHtml(store.logo) + '"' +
          ' alt="' + escapeHtml(store.title) + '"' +
          ' class="store-logo-img"' +
          ' loading="lazy"' +
          ' decoding="async"' +
          ' width="56" height="56"' +
          ' referrerpolicy="no-referrer"' +
          ' onerror="this.remove()">';
      }

      // Compact icon actions. Each is a real link so it keeps native
      // behaviour (open in tab, long-press, copy address); only the ones a
      // store actually has data for are rendered.
      var actions = '';
      if (store.website) {
        actions +=
          '<a class="store-action" href="' + escapeHtml(store.website) + '"' +
          ' target="_blank" rel="noopener noreferrer"' +
          ' title="Visit website" aria-label="Visit ' + escapeHtml(store.title) + ' website">' +
            ICON_GLOBE +
          '</a>';
      }
      if (store.phone) {
        actions +=
          '<a class="store-action" href="tel:' + escapeHtml(store.phone.replace(/[^\d+]/g, '')) + '"' +
          ' title="Call ' + escapeHtml(store.phone) + '"' +
          ' aria-label="Call ' + escapeHtml(store.title) + ' on ' + escapeHtml(store.phone) + '">' +
            ICON_PHONE +
          '</a>';
      }
      if (store.position) {
        actions +=
          '<a class="store-action" href="https://www.google.com/maps/dir/?api=1&destination=' +
          encodeURIComponent(store.position.lat + ',' + store.position.lng) + '"' +
          ' target="_blank" rel="noopener noreferrer"' +
          ' title="Directions" aria-label="Directions to ' + escapeHtml(store.title) + '">' +
            ICON_PIN +
          '</a>';
      }

      // Three columns: logo, text, actions. Keeping the buttons in their own
      // column rather than stacked under the text removes a whole row per
      // card, so noticeably more distributors fit without scrolling.
      card.innerHTML =
        '<div class="store-col store-col-image">' + logoHtml + '</div>' +
        '<div class="store-col store-col-info">' +
          '<h4>' + escapeHtml(store.title) + '</h4>' +
          '<p class="store-category">' + escapeHtml(store.category || '') + '</p>' +
          '<p class="store-address" title="' + escapeHtml(store.address || '') + '">' +
            distanceText + escapeHtml(store.address || '') + '</p>' +
        '</div>' +
        (actions ? '<div class="store-col store-actions">' + actions + '</div>' : '');

      // Without a map there is nothing for the card to focus, so it stays a
      // plain row and the icon links carry the actions.
      if (!map) return card;

      // The whole card focuses the store on the map; the icon links keep
      // their own behaviour and must not trigger the fly-to.
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Show ' + store.title + ' on the map');

      function focusStore() {
        viewIsUsers = true;
        map.flyTo([store.position.lat, store.position.lng], 14, { duration: 1 });
        if (store._marker) store._marker.openPopup();
      }

      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        focusStore();
      });

      card.addEventListener('keydown', function (e) {
        if (e.target.closest('a')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          focusStore();
        }
      });

      return card;
    }

    function renderStores(stores, searchLat, searchLng) {
      if (!listContainer) return;
      while (listContainer.firstChild) listContainer.removeChild(listContainer.firstChild);
      if (stockistCount) stockistCount.textContent = stores.length + ' FOUND';

      var frag = document.createDocumentFragment();
      for (var i = 0; i < stores.length; i++) {
        frag.appendChild(buildCard(stores[i], searchLat, searchLng));
      }
      listContainer.appendChild(frag);
    }

    // Seed markers + list
    if (window.merchantStoresData && window.merchantStoresData.length > 0) {
      window.merchantStoresData.forEach(function (store) {
        if (!store.position) return;
        if (map) {
          var marker = L.marker([store.position.lat, store.position.lng], { icon: customIcon }).addTo(map);
          marker.bindPopup(
            "<div style='text-align:center;'>" +
              "<b>" + escapeHtml(store.title) + "</b><br>" +
              "<span style='font-size:11px;color:#666;'>" + escapeHtml(store.category || '') + "</span><br>" +
              "<span style='font-size:10px;'>" + escapeHtml(store.address || '') + "</span>" +
            "</div>"
          );
          store._marker = marker;
          bounds.extend([store.position.lat, store.position.lng]);
        }
        allStores.push(store);
      });

      fitToStores();
      renderStores(allStores);

      // The opening fit runs as soon as the DOM is parsed, and how much map
      // is usable depends on how much of it the directory panel covers. If
      // that panel's geometry is still settling at that instant, the first
      // frame is computed against the wrong box and pins end up behind it —
      // measured at 1024px wide, seven of twenty landed under the panel.
      // Re-running it once the layout has settled costs nothing and is
      // skipped outright the moment the view belongs to the visitor.
      settleFit = function () { if (!viewIsUsers) fitToStores(); };
      setTimeout(settleFit, 0);
      setTimeout(settleFit, 300);
      window.addEventListener('load', settleFit);
    } else if (stockistCount) {
      stockistCount.textContent = '0 FOUND';
    }

    // Re-measure for the rest of the page's life, and re-frame the stores with
    // it. A resize changes how much map there is and how much of it the
    // directory panel covers, so the overview has to be recomputed or pins
    // end up off-screen or behind the panel. Once the visitor has moved the
    // map themselves, or searched, their view is theirs and is left alone —
    // except when the stores were never framed properly in the first place.
    if (map) {
      watchSize(mapEl, map, function () {
        if (needsFit || !viewIsUsers) fitToStores();
      });
    }

    // Stop halo pulse after the initial attention window (saves GPU on idle)
    setTimeout(function () { mapEl.classList.add('halo-settled'); }, 4000);

    // Search
    var searchInput = document.getElementById('stockistSearchInput');
    var searchBtn = document.getElementById('stockistSearchBtn');
    var searchDebounce;
    var currentAbort;

    function textFilter(query) {
      var q = query.toLowerCase();
      return allStores.filter(function (s) {
        return (s.title || '').toLowerCase().indexOf(q) !== -1 ||
               (s.address && s.address.toLowerCase().indexOf(q) !== -1);
      });
    }

    function doSearch() {
      if (!searchInput) return;
      var query = searchInput.value.trim();
      if (!query) {
        renderStores(allStores);
        viewIsUsers = false;
        fitToStores();
        return;
      }

      if (currentAbort) currentAbort.abort();
      currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;

      var url = 'https://nominatim.openstreetmap.org/search?format=json&q=' +
                encodeURIComponent(query + ', UK') + '&limit=1';

      var fetchOpts = currentAbort ? { signal: currentAbort.signal } : undefined;

      fetch(url, fetchOpts)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.length > 0) {
            var lat = parseFloat(data[0].lat);
            var lng = parseFloat(data[0].lon);
            var sorted = allStores.slice().map(function (s) {
              s._distance = getDistance(lat, lng, s.position.lat, s.position.lng);
              return s;
            }).sort(function (a, b) { return a._distance - b._distance; });
            renderStores(sorted, lat, lng);
            if (map) {
              needsFit = false;
              viewIsUsers = true;
              map.setView([lat, lng], 10);
            }
          } else {
            renderStores(textFilter(query));
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          renderStores(textFilter(query));
        });
    }

    if (searchBtn) searchBtn.addEventListener('click', doSearch);
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(doSearch, 350);
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(searchDebounce);
          doSearch();
        }
      });
    }
  }

  // Deferred script: DOM is parsed. Leaflet is loaded earlier in the defer queue.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor swaps the section's markup in place, which throws away
  // the old map node without reloading the page.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#merchant-map')) init();
  });
})();
